<div class="modal-header">
  <h4 class="modal-title">{{ title | translate }}</h4>
  <button type="button" class="close" (click)="closeModal()">{{ 'removeModal.modalHeader.closeButton' | translate }}</button>
</div>
<div class="modal-body">
  <p [innerHTML]="body"></p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="confirmAndClose()">{{ confirmButtonText | translate }}</button>
  <button type="button" class="btn btn-secondary" (click)="cancelAndClose()">{{ cancelButtonText | translate }}</button>
</div>
